import React from 'react';
// import { Col, Form, Row } from 'react-bootstrap';
// import StopLightWithMessage from './StopLightWithMessage';
import { PaymentDataType } from './SummaryPaymentModal';
import { dateFormatter, formatToDecimals } from '@lib/helpers/formatting';
import SummaryInfoList from './SummaryInfoList';

interface SummaryPaymentModalInfoProps {
	paymentData: PaymentDataType;
}

const SummaryPaymentModalInfo: React.FC<SummaryPaymentModalInfoProps> = ({ paymentData }) => {
	const items = [
		{
			label: 'Nome Beneficiario',
			value: paymentData?.payeeName ?? 'N.D.',
		},
		{
			label: 'Codice Beneficiario',
			value: paymentData?.payeeCode ?? 'N.D.',
		},
		{
			label: 'Nome Beneficiario Definitivo (Factor)',
			value: paymentData?.lastPayeeName ?? 'N.D.',
		},
		{
			label: 'Tipologia Pagamento',
			value: paymentData?.paymentType ?? 'N.D.',
		},
		{
			label: 'Nr. Pagamento',
			value: paymentData?.paymentNumber ?? 'N.D.',
		},
		{
			label: 'Cod. Proposta Amm.Ne Richiedente (Mandato)',
			value: paymentData?.proposalCode ?? 'N.D.',
		},
		{
			label: 'Data Pagamento',
			value: paymentData?.date ? dateFormatter(paymentData?.date) : 'N.D.',
		},
		{
			label: 'Divisa di Pagamento',
			value: paymentData?.currencyCode ?? 'N.D.',
		},
		{
			label: 'CRO/Swift Code Pagamento',
			value: paymentData?.cro ?? 'N.D',
		},
	];

	const invoiceItems = [
		{
			label: 'Codice ERP',
			value: paymentData.invoice?.rpCode ?? 'N.D.',
		},
		{
			label: 'Nr. Fattura',
			value: paymentData.invoice?.number ?? 'N.D.',
		},
		{
			label: 'Imponibile Fattura €',
			value: paymentData.invoice?.taxableAmount ? formatToDecimals(paymentData.invoice?.taxableAmount) : 'N.D',
		},
		{
			label: 'Importo Fattura da Avviso €',
			value: paymentData.invoice?.totalAmount ? formatToDecimals(paymentData.invoice?.totalAmount) : 'N.D.',
		},
	];
	return (
		<div className="summary_info-container">
			<div>
				<h4>Dati pagamento</h4>

				<SummaryInfoList items={items} />
			</div>
			<hr />
			<div>
				<h4>Fattura</h4>
				{!paymentData?.invoice ? (
					<p>Non sono presenti fatture.</p>
				) : (
					<>
						<div
							style={{
								backgroundColor: '#edf0f7',
								padding: '1rem',
								borderRadius: '8px',
								display: 'flex',
								justifyContent: 'space-between',
								marginBottom: '1.5rem',
							}}
						>
							<div style={{ fontWeight: 700 }}>{invoiceItems[0].label}</div>
							<div>{invoiceItems[0].value}</div>
						</div>
						<SummaryInfoList items={invoiceItems.slice(1)} noBg />
					</>
				)}
			</div>
		</div>
	);
	//   <>
	// 										<Row style={{ marginBottom: '40px' }}>
	// 											<Col
	// 												style={{
	// 													backgroundColor: '#EDF0F7',
	// 													padding: '1rem',
	// 													borderRadius: '8px',
	// 													display: 'flex',
	// 													gap: '10px',
	// 													alignItems: 'center',
	// 													justifyContent: 'space-between',
	// 													paddingBlock: '18px',
	// 												}}
	// 											>
	// 												<p
	// 													style={{
	// 														marginTop: 'auto',
	// 														marginBottom: 0,
	// 														fontWeight: 700,
	// 														fontSize: '16px',
	// 													}}
	// 												>
	// 													Stato della Procedura
	// 												</p>
	// 												<div
	// 													style={{
	// 														marginBottom: 'auto',
	// 													}}
	// 												>
	// 													<StopLightWithMessage checklistColor={paymentData.checkliststatus?.color} messageStyles={{ fontWeight: 500 }} />
	// 												</div>
	// 											</Col>
	// 										</Row>
	// 										<Row style={{ marginBottom: '40px' }}>
	// 											<Form.Group as={Col}>
	// 												<Form.Label>Nome Beneficiario</Form.Label>
	// 												<Form.Text as="p">{paymentData?.payeeName ?? 'N.D.'}</Form.Text>
	// 											</Form.Group>

	// 											<Form.Group as={Col}>
	// 												<Form.Label>Codice Beneficiario</Form.Label>
	// 												<Form.Text as="p">{paymentData?.payeeCode ?? 'N.D.'}</Form.Text>
	// 											</Form.Group>

	// 											<Form.Group as={Col}>
	// 												<Form.Label>Nome Beneficiario Definitivo (Factor)</Form.Label>
	// 												<Form.Text as="p">{paymentData?.lastPayeeName ?? 'N.D.'}</Form.Text>
	// 											</Form.Group>
	// 										</Row>

	// 										<Row style={{ marginBottom: '40px' }}>
	// 											<Form.Group as={Col}>
	// 												<Form.Label>Tipologia Pagamento</Form.Label>
	// 												<Form.Text as="p">{paymentData?.paymentType ?? 'N.D.'}</Form.Text>
	// 											</Form.Group>

	// 											<Form.Group as={Col}>
	// 												<Form.Label>Nr. Pagamento</Form.Label>
	// 												<Form.Text as="p">{paymentData?.paymentNumber ?? 'N.D.'}</Form.Text>
	// 											</Form.Group>

	// 											<Form.Group as={Col}>
	// 												<Form.Label>Cod. Proposta Amm.Ne Richiedente (Mandato)</Form.Label>
	// 												<Form.Text as="p">{paymentData?.proposalCode ?? 'N.D.'}</Form.Text>
	// 											</Form.Group>
	// 										</Row>

	// 										<Row style={{ marginBottom: '40px' }}>
	// 											<Form.Group as={Col}>
	// 												<Form.Label>Data Pagamento</Form.Label>
	// 												<Form.Text as="p">{paymentData?.date ? dateFormatter(paymentData?.date) : 'N.D.'}</Form.Text>
	// 											</Form.Group>

	// 											<Form.Group as={Col}>
	// 												<Form.Label className="mb-3">Divisa di Pagamento</Form.Label>
	// 												<Form.Text as="p">{paymentData?.currencyCode ?? 'N.D.'}</Form.Text>
	// 											</Form.Group>

	// 											<Form.Group as={Col}>
	// 												<Form.Label>CRO/Swift Code Pagamento</Form.Label>
	// 												<Form.Text as="p">{paymentData?.cro ?? 'N.D'}</Form.Text>
	// 											</Form.Group>

	// 											<Row className="flex-column">
	// 												<Col>
	// 													<h2>Fattura</h2>
	// 												</Col>
	// 											</Row>
	// 											{!paymentData?.invoice ? (
	// 												<Row className="text-center my-5">
	// 													<span>Non sono presenti fatture.</span>
	// 												</Row>
	// 											) : (
	// 												<>
	// 													<Row style={{ marginBottom: '40px' }}>
	// 														<Form.Group as={Col}>
	// 															<Form.Label>Codice ERP</Form.Label>
	// 															<Form.Text as="p">{paymentData.invoice?.rpCode ?? 'N.D.'}</Form.Text>
	// 														</Form.Group>

	// 														<Form.Group as={Col}>
	// 															<Form.Label>Nr. Fattura</Form.Label>
	// 															<Form.Text as="p">{paymentData.invoice?.number ?? 'N.D.'}</Form.Text>
	// 														</Form.Group>

	// 														<Form.Group as={Col}>
	// 															<Form.Label>Imponibile Fattura €</Form.Label>
	// 															<Form.Text as="p">
	// 																{paymentData.invoice?.taxableAmount ? formatToDecimals(paymentData.invoice?.taxableAmount) : 'N.D'}
	// 															</Form.Text>
	// 														</Form.Group>
	// 													</Row>
	// 													<Row>
	// 														<Form.Group as={Col}>
	// 															<Form.Label>Importo Fattura da Avviso €</Form.Label>
	// 															<Form.Text as="p">
	// 																{paymentData.invoice?.totalAmount ? formatToDecimals(paymentData.invoice?.totalAmount) : 'N.D.'}
	// 															</Form.Text>
	// 														</Form.Group>
	// 													</Row>
	// 												</>
	// 											)}
	// 										</Row>
	// 									</>
};

export default SummaryPaymentModalInfo;
